import dayjs from 'dayjs';

function getWeekDays(weekStart) {
  const days = [weekStart];
  for (let i = 1; i < 7; i += 1) {
    days.push(
      dayjs(weekStart)
        .add(i, 'day')
        .toDate()
    );
  }
  return days;
}

function getWeekRange(date) {
  return {
    from: dayjs(date).startOf('week').toDate(),
    to: dayjs(date).endOf('week').toDate(),
  };
}

export { getWeekDays, getWeekRange }